import Vue from "vue";
import Router from "vue-router";
import { requireAuth } from "@/service/requireAuth";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    { path: "", redirect: "/factory/login" },
    {
      path: "/factory",
      component: () => import("@/page/factory/main.vue"),
      children: [
        { path: "", redirect: "/factory/login" },
        {
          path: "login",
          name: "factorylogin",
          component: () => import("@/page/factory/login.vue")
        },
        {
          path: "reservation",
          name: "reservation",
          component: () => import("@/page/factory/reservation.vue"),
          beforeEnter: requireAuth,
          meta: "factory"
        },
        {
          path: "customer/:code",
          name: "customer",
          component: () => import("@/components/CustomerScreen.vue"),
          meta: "factory",
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: "inspectiondetail",
          name: "inspectiondetail",
          component: () => import("@/page/factory/inspectionDetail.vue"),
          meta: "factory",
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: "inspection",
          component: () => import("@/components/MainInspection.vue"),
          meta: "factory",
          props: true,
          beforeEnter: requireAuth,
          children: [
            { path: "", redirect: "/factory/inspection/carselection" },
            {
              path: "carselection",
              name: "carselection",
              component: () => import("@/page/factory/carSelection.vue"),
              meta: "factory",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "inspectline",
              name: "inspectline",
              component: () => import("@/page/factory/inspectLine.vue"),
              meta: "factory",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "standby",
              name: "standby1",
              component: () => import("@/page/factory/intermediateStandby.vue"),
              meta: "factory",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "standby/:page",
              name: "standby",
              component: () => import("@/page/factory/intermediateStandby.vue"),
              meta: "factory",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "gensha",
              name: "currentcarcheck",
              component: () =>
                import("@/page/factory/inspectionSelections.vue"),
              meta: "factory",
              beforeEnter: requireAuth
            },
            {
              path: "legal56",
              name: "legal56",
              component: () =>
                import("@/page/factory/inspectionSelections.vue"),
              meta: "factory",
              beforeEnter: requireAuth
            },
            {
              path: "recommend",
              name: "recmaintenance",
              component: () => import("@/page/factory/recMaintenance.vue"),
              meta: "factory",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "workorder",
              name: "workorder",
              component: () => import("@/page/factory/workOrder.vue"),
              meta: "factory",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "partselection",
              name: "partsselect",
              component: () => import("@/page/factory/partSelection.vue"),
              meta: "factory",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "jizen",
              name: "jizen",
              component: () =>
                import("@/page/factory/inspectionSelections.vue"),
              meta: "factory",
              beforeEnter: requireAuth
            },
            {
              path: "estimate",
              name: "estimate",
              component: () =>
                import("@/page/factory/estimateDetail.vue"),
              meta: "factory",
              beforeEnter: requireAuth
            }
          ]
        },
        {
          path: "additional-maintenance",
          name: "additional-maintenance",
          component: () => import("@/page/factory/additionalMaintenance.vue"),
          meta: "factory",
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: "completed",
          name: "completed",
          component: () => import("@/page/factory/completed.vue"),
          meta: "factory",
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: "carselection-quick-info",
          name: "quickinfo",
          component: () => import("@/page/factory/quickInfo.vue"),
          meta: "factory",
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: "quick",
          component: () => import("@/components/mainQuick.vue"),
          meta: "factory",
          props: true,
          beforeEnter: requireAuth,
          children: [
            
            {
              path: "item-selection",
              name: "quickitemselection",
              component: () => import("@/page/factory/recMaintenanceQuick.vue"),
              meta: "factory",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "mitsumori",
              name: "quickmitsumori",
              component: () => import("@/page/factory/quickMitsumori.vue"),
              meta: "factory",
              props: true,
              beforeEnter: requireAuth
            }
          ]
        }
      ]
    },
    {
      path: "/user",
      component: () => import("@/page/user/main.vue"),
      children: [
        { path: "", redirect: "/user/login" },
        {
          path: "login",
          name: "userlogin",
          component: () => import("@/page/user/login.vue")
        },
        {
          path: "usermenu",
          name: "usermenu",
          component: () => import("@/page/user/userMenu.vue"),
          beforeEnter: requireAuth,
          meta: "user"
        },
        {
          path: "reservationNumber",
          name: "reservationNumber",
          component: () => import("@/page/user/reservationNumber.vue"),
          beforeEnter: requireAuth,
          meta: "user"
        },
        {
          path: "customer/:code",
          name: "usercustomer",
          component: () => import("@/components/CustomerScreen.vue"),
          meta: "user",
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: "inspection",
          component: () => import("@/components/MainInspection.vue"),
          meta: "user",
          props: true,
          beforeEnter: requireAuth,
          children: [
            { path: "", redirect: "/user/inspection/statusresult" },
            {
              path: "statusresult",
              name: "statusresult",
              component: () => import("@/page/user/statusResult.vue"),
              meta: "user",
              beforeEnter: requireAuth
            },
            {
              path: "workdetail",
              name: "workdetail",
              component: () => import("@/page/user/WorkDetail.vue"),
              meta: "user",
              beforeEnter: requireAuth,
              props: true
            },
            {
              path: "inspectioncost",
              name: "inspectioncost",
              component: () => import("@/page/user/InspectionCostPage.vue"),
              meta: "user",
              beforeEnter: requireAuth
            },
            {
              path: "legal56",
              name: "userlegal56",
              component: () => import("@/page/user/InspectList.vue"),
              meta: "user",
              beforeEnter: requireAuth
            },
            {
              path: "recommend",
              name: "userrecommend",
              component: () => import("@/page/user/InspectList.vue"),
              meta: "user",
              beforeEnter: requireAuth
            },
            {
              path: "paymentdetail",
              name: "paymentdetail",
              component: () => import("@/page/user/paymentDetail.vue"),
              meta: "user",
              beforeEnter: requireAuth
            },
            {
              path: "discountcoupon",
              name: "discountcoupon",
              component: () => import("@/page/user/CouponPage.vue"),
              meta: "user",
              beforeEnter: requireAuth
            },
            {
              path: "workorder",
              name: "userworkorder",
              component: () => import("@/page/factory/workOrder.vue"),
              meta: "user",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "option",
              name: "option",
              component: () => import("@/page/user/OptionPage.vue"),
              meta: "user",
              props: true,
              beforeEnter: requireAuth
            },
          ]
        },
        {
          path: "reservenext",
          name: "reservenext",
          component: () => import("@/page/user/ReserveNext.vue"),
          meta: "user",
          beforeEnter: requireAuth
        },
        {
          path: "complete",
          name: "usercomplete",
          component: () => import("@/page/user/CompleteUserPage.vue"),
          meta: "user",
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: "mitsumori-list",
          name: "quickmitsumorilist",
          component: () => import("@/page/user/quickMitsumoriList.vue"),
          meta: "user",
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: "carselection-quick-info/:code",
          name: "user-quickinfo",
          component: () => import("@/page/user/quickInfoUser.vue"),
          meta: "user",
          props: true,
          beforeEnter: requireAuth
        },
        {
          path: "quick",
          component: () => import("@/components/mainQuick.vue"),
          meta: "user",
          props: true,
          beforeEnter: requireAuth,
          children: [
            { // 使っていない
              path: "mitsumori",
              name: "userquickmitsumori",
              component: () => import("@/page/factory/quickMitsumori.vue"),
              meta: "user",
              props: true,
              beforeEnter: requireAuth
            },
            { // 使っていない
              path: "seibi",
              name: "quickseibilist",
              component: () => import("@/page/user/quickSeibiList.vue"),
              meta: "user",
              props: true,
              beforeEnter: requireAuth
            },
            { // 使っていない
              path: "inspection-cost",
              name: "userinspectioncost",
              component: () => import("@/page/user/InspectionCostPageQuick.vue"),
              meta: "user",
              props: true,
              beforeEnter: requireAuth
            },
            { // 使っていない
              path: "discountcoupon",
              name: "quickdiscountcoupon",
              component: () => import("@/page/user/CouponPageQuick.vue"),
              meta: "user",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "user-item-selection",
              name: "user-quickitemselection",
              component: () => import("@/page/user/recMaintenanceQuickUser.vue"),
              meta: "user",
              props: true,
              beforeEnter: requireAuth
            },
            {
              path: "user-mitsumori",
              name: "user-quickmitsumori",
              component: () => import("@/page/user/quickMitsumoriUser.vue"),
              meta: "user",
              props: true,
              beforeEnter: requireAuth
            }
          ]
        }
      ]
    },
    {
      path: "/front",
      component: () => import("@/page/front/main.vue"),
      children: [
        { path: "", redirect: "/front/login" },
        {
          path: "login",
          name: "frontlogin",
          component: () => import("@/page/front/login.vue")
        }
      ]
    }
  ]
});
